"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactMlsdata = require("./react-mlsdata");

var _widget = require("./widget");

var _widget2 = _interopRequireDefault(_widget);

require("./css/main.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KPIWidget = function (_Component) {
  _inherits(KPIWidget, _Component);

  function KPIWidget(props) {
    _classCallCheck(this, KPIWidget);

    return _possibleConstructorReturn(this, (KPIWidget.__proto__ || Object.getPrototypeOf(KPIWidget)).call(this, props));
  }

  _createClass(KPIWidget, [{
    key: "render",
    value: function render() {
      var _props = _extends({}, this.props),
          assets = _props.assets,
          widgetselections = _props.widgetselections,
          title = _props.title;

      var _widgetselections = _extends({}, widgetselections),
          measure = _widgetselections.measure,
          geographytype = _widgetselections.geographytype,
          geographyvalue = _widgetselections.geographyvalue,
          measurelabel = _widgetselections.measurelabel,
          geo = _widgetselections.geo;

      var select = measure;

      var geofilter = [];
      geo.forEach(function (geo) {
        var g1 = geo.split(":")[0];
        var g2 = geo.split(":")[1];
        var geoquery = { and: [{ GeographyType: "" + g1 }, { GeographyName: "" + g2 }] };
        geofilter.push(geoquery);
      });

      var filter = { and: [{ Class: 'Residential - Single Family' }, { or: geofilter }] };
      var widget = measure == "" ? "" : _react2.default.createElement(
        _reactMlsdata.MLSStats,
        { collection: "MarketTrendsLast30", filter: filter },
        function (_ref) {
          var loading = _ref.loading,
              error = _ref.error,
              data = _ref.data;
          return _react2.default.createElement(
            "div",
            { className: "kpi " + (loading ? "loading" : "") },
            loading && _react2.default.createElement(
              "div",
              { className: "kpiloader msg pos-absolute" },
              "Loading..."
            ),
            error && _react2.default.createElement(
              "h2",
              null,
              "" + error
            ),
            data && _react2.default.createElement(_widget2.default, { title: title,
              assets: assets,
              widgetselections: widgetselections,
              data: data.value
            })
          );
        }
      );

      return _react2.default.createElement(
        "div",
        { id: "kpiwidget-container", className: "px-0 container" },
        widget
      );
    }
  }]);

  return KPIWidget;
}(_react.Component);

exports.default = KPIWidget;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-aculistkpiwidget/lib/index.js
// module id = 213
// module chunks = 0